<template>
	<div class="top-session-button__container" style="display: flex">
		<div v-if="isBalanceActive" class="topnav__balance__widget__inner">
			<span @click="$router.push({ path: '/profile/deposit' })" class="actual_balance">{{ balance | currency }}</span>
			<svg
				width="18"
				height="18"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				@click="showBalance(false)"
			>
				<path
					d="M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.42004 13.9799 8.42004 11.9999C8.42004 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
      
    </div>
		<div v-else class="topnav__balance__widget__inner">
			<div @click="$router.push({ path: '/profile/deposit' })" class="actual_balance">
				<span>{{ env.currency }}</span
				>&nbsp;<span class="topnav__balance__widget__inner--asterix"
					>*****</span
				>
			</div>
			<svg
				width="18"
				height="18"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				@click="showBalance(true)"
			>
				<path
					d="M14.53 9.46992L9.47004 14.5299C8.82004 13.8799 8.42004 12.9899 8.42004 11.9999C8.42004 10.0199 10.02 8.41992 12 8.41992C12.99 8.41992 13.88 8.81992 14.53 9.46992Z"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M17.82 5.76998C16.07 4.44998 14.07 3.72998 12 3.72998C8.46997 3.72998 5.17997 5.80998 2.88997 9.40998C1.98997 10.82 1.98997 13.19 2.88997 14.6C3.67997 15.84 4.59997 16.91 5.59997 17.77"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M8.42004 19.5299C9.56004 20.0099 10.77 20.2699 12 20.2699C15.53 20.2699 18.82 18.1899 21.11 14.5899C22.01 13.1799 22.01 10.8099 21.11 9.39993C20.78 8.87993 20.42 8.38993 20.05 7.92993"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M9.47 14.53L2 22"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M22 2L14.53 9.47"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
      
		</div>
    <div @click="$router.push({ path: '/profile/deposit' })" class="add-funds-button">
      <span class="plus-icon">+</span>
    </div>
    
	</div>
</template>
<script>
export default {
	name: "TopSessionBalanceInfo",
	data() {
		return {
			isBalanceActive: false,
		};
	},
	computed: {
		balance() {
			return this.$store.getters.balance == 0
				? JSON.parse(window.localStorage.getItem("user")).balance
				: this.$store.getters.balance;
		},
	},
	methods: {
		showBalance(status) {
			this.isBalanceActive = status;
		},
		updateBalance() {
			this.$axios
				.post(`${BASE_URL}balance`, {
					token: window.localStorage.getItem("token")
						? JSON.parse(window.localStorage.getItem("token"))
						: "",
				})
				.then((response) => {
					this.$store.commit("setBalance", response.data.data.balance);
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
	mounted() {
		let vm = this;
		vm.updateBalance();
		vm.isBalanceActive = vm.$store.getters.layout === "Mobile" && this.env.mobileTopSessionBalanceVisible;
	},
	created() {
		let vm = this;
		vm.$root.$on("update-user-balance", vm.updateBalance);
	},
	beforeDestroy() {
		let vm = this;
		vm.$root.$off("update-user-balance", vm.updateBalance);
	},
};
</script>
<style lang="scss" scoped>
.actual_balance {
  padding-right: 5px;
}

header .topnav__balance__widget__inner {
  color: var(--black) !important;
}

.add-funds-button {
  width: 25px;
  height: 25px;
  background-color: #557240; /* Green color from image */
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  .plus-icon {
    color: white;
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
  }
}

.top-session-button {
	font-size: var(--font-small);
	border-radius: 8px;
	font-weight: var(--font-weight-medium);
	&__container {
    border: 0.2px solid var(--black);
    padding: 2px 2px 2px 4px !important;
    border-radius: 7px !important;
    margin-right: 10px;

		.button__primary {
			border: 0px;
		}
		.button__secondary {
			border: 0px;
			&.outline {
				font-weight: var(--font-weight-bold);
			}
		}
	}
}
</style>